import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import {
  disableNotificationByUserId,
  markAllAsReadByUserId,
  markAsReadByNotificationId,
} from '../services/notificationServices';
import DisableNotifications from '../models/disable-notifications.dto';

export const useMakeOneAsRead = () => {
  const useMakeAsReadByNotificationIdMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { notificationId: string },
    unknown
  >((mutationVariables) =>
    markAsReadByNotificationId(mutationVariables.notificationId),
  );

  return useMakeAsReadByNotificationIdMutation;
};

export const useDisableNotification = () => {
  const useDisableNotificationByUserIdMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { userId: string | undefined; payload: DisableNotifications },
    unknown
  >((mutationVariables) =>
    disableNotificationByUserId(
      mutationVariables.userId,
      mutationVariables.payload,
    ),
  );

  return useDisableNotificationByUserIdMutation;
};

export const useMakeAllAsRead = () => {
  const useMakeAllAsReadByUserIdMutation = useMutation<
    AxiosResponse<null>,
    unknown,
    { userId: string | undefined },
    unknown
  >((mutationVariables) => markAllAsReadByUserId(mutationVariables.userId));

  return useMakeAllAsReadByUserIdMutation;
};
